import { useContext } from "react";
import AuthContext from "../../components/auth-context";
import SGrid from "../../components/sgrid";
import Button from "../../components/tailwind/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SpeedTestApi from "../../api/speed-test";
import AppLink from "../../components/router/app-link";

function SpeedTestResult() {
  const context = useContext(AuthContext);
  const { activeFileId } = context;

  if (!activeFileId) {
    return <div>در حال بارگذاری...</div>;
  }

  const dataProvider = (page: number, pageSize: number) => {
    return new SpeedTestApi(context).getAll(activeFileId, page, pageSize);
  };

  return (
    <>
      <Button
        className="btn bgc-white d-lg-inline-block btn-light-secondary mx-0"
        dataToggle="tooltip"
      >
        <AppLink to="/speedTest/">
          <FontAwesomeIcon icon="rocket" className="text-green" />
          <small className="ml-2 mr-1">سنجش سرعت</small>
        </AppLink>
      </Button>

      <div className="card dcard overflow-x-scroll" style={{ padding: "5px" }}>
        <SGrid
          dataProvider={dataProvider}
          columns={[
            "",
            "",
            ["تاریخ", "date", 2],
            ["IP", "farsi", 3],
            ["(Ping)تاخیر", "farsi", 4],
            ["(Jitter)اعوجاج", "farsi", 5],
            ["آپلود", "farsi", 6],
            ["دانلود", "farsi", 7],
          ]}
        />
      </div>
    </>
  );
}

export default SpeedTestResult;
